import { render, staticRenderFns } from "./aufgaben-comments.vue?vue&type=template&id=e6ea6c6c"
import script from "./aufgaben-comments.vue?vue&type=script&lang=js"
export * from "./aufgaben-comments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports